import { put } from 'redux-saga/effects'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getSelectedDataFromObject } from '../../../../utilities/data.util'
import { initialCardioNabc, initialCardioPm } from '../store/cardio.reducers'
import { saveInitialAssessmentCardiPrPm, saveInitialAssessmentCardioNabc, setPrCvAssess } from '../store/cardio.actions'

export function* getInitialAssessmentCardio(pcrDoc: IPcr) {
  if (pcrDoc && pcrDoc.prNabc) {
    const initialAssessmentCardioaNabc = pcrDoc.prNabc
    const prNabcKeys: any = Object.keys(initialCardioNabc)
    const prNabcData = getSelectedDataFromObject(initialAssessmentCardioaNabc, prNabcKeys)
    if (pcrDoc.prPm) {
      const initialAssessmentCardioaPrpm = pcrDoc.prPm[0]
      const ppPmKeys: any = Object.keys(initialCardioPm)
      const prPmData = getSelectedDataFromObject(initialAssessmentCardioaPrpm, ppPmKeys)
      if (Object.keys(prPmData).length > 0) yield put(saveInitialAssessmentCardiPrPm(pcrDoc.prPm[0]))
    }
    if (Object.keys(prNabcData).length > 0) yield put(saveInitialAssessmentCardioNabc(prNabcData))
  }
  if (pcrDoc.prCvAssess?.length > 0) yield put(setPrCvAssess(pcrDoc.prCvAssess))
}
